import styled from "styled-components";
import { SPACING } from "../../../../../utils/constants";

export {
  InsetSectionCard as ContributionsCard,
  SectionHeaderRow as HeaderRow,
  SectionTitleBlock as TitleBlock,
  SectionTitle as Title,
  SectionSubtitle as Subtitle,
  SectionBadge as Badge,
  SectionHeaderToggle as HeaderToggle,
  SectionChevron as Chevron,
  SectionTable as Table,
  SectionHeaderCell as HeaderCell,
  SectionCardList as CardList,
  SectionCardRow as CardRow,
  SectionMessage as Message,
} from "../SectionCard/styles";

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
`;

/* ------------------------------ Desktop table ----------------------------- */

const rowGrid = `
  display: grid;
  grid-template-columns: minmax(110px, 1.3fr) 1fr 1fr 1fr 40px;
  align-items: center;
  gap: ${SPACING.md}px;
`;

export const TableHead = styled.div`
  ${rowGrid}
  padding: 0 ${SPACING.sm}px ${SPACING.sm}px;
  border-bottom: 1px solid var(--color-card-border);
`;

export const Row = styled.div`
  ${rowGrid}
  padding: ${SPACING.md}px ${SPACING.sm}px;
  border-bottom: 1px solid var(--color-card-border);
  border-radius: 8px;
  transition: background 0.15s ease;

  &:hover {
    background: color-mix(in srgb, var(--color-text-muted) 5%, transparent);
  }
`;

export const DateCell = styled.span`
  color: var(--color-text-default);
  font-weight: 600;
  font-size: var(--text-md);
`;

export const ChangeCell = styled.span<{ $positive: boolean }>`
  color: ${({ $positive }) =>
    $positive ? "var(--color-success)" : "var(--color-error)"};
  font-weight: 700;
  font-size: var(--text-md);
`;

export const InvestedCell = styled.span`
  color: var(--color-text-secondary);
  font-size: var(--text-md);
`;

export const ValueCell = styled.span`
  color: var(--color-text-default);
  font-weight: 700;
  font-size: var(--text-md);
`;

export const KebabCell = styled.div`
  display: flex;
  justify-content: flex-end;
`;

/* ------------------------------ Mobile cards ------------------------------ */

export const CardTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${SPACING.sm}px;
`;

export const CardDate = styled.span`
  color: var(--color-text-default);
  font-weight: 600;
  font-size: var(--text-md);
`;

export const CardChange = styled.span<{ $positive: boolean }>`
  color: ${({ $positive }) =>
    $positive ? "var(--color-success)" : "var(--color-error)"};
  font-weight: 700;
  font-size: var(--text-xxl);
  letter-spacing: -0.01em;
`;

export const CardMeta = styled.span`
  color: var(--color-text-secondary);
  font-size: var(--text-base);
`;

/* --------------------------------- Footer --------------------------------- */

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${SPACING.md}px;
  margin-top: ${SPACING.xs}px;
`;

export const FooterText = styled.span`
  font-style: italic;
  color: var(--color-text-secondary);
  font-size: var(--text-base);
`;

export const LoadMoreLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs}px;
`;

/* --------------------------------- States --------------------------------- */

export { SkeletonLine } from "../../styles";

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.md}px;
  padding: ${SPACING.md}px ${SPACING.sm}px;
  border-bottom: 1px solid var(--color-card-border);
`;
